import { Controller } from '@hotwired/stimulus'

// Asks the page's datatable to fetch its rows again, for work that finished somewhere else.
// It is rendered by a broadcast, so arriving on the page is the whole signal.
export default class extends Controller {
  connect () {
    this.dispatch('reload', { target: window, prefix: 'datatable' })

    this.element.remove()
  }
}
